var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-menu', {
    attrs: {
      "top": "",
      "offset-y": "",
      "content-class": "v-menu--tooltip"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
            on = _ref.on;
        return [_c('v-hover', {
          model: {
            value: _vm.shows,
            callback: function callback($$v) {
              _vm.shows = $$v;
            },
            expression: "shows"
          }
        }, [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on
        })], 2)];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-card', {
    staticClass: "v-card--tooltip",
    attrs: {
      "tile": ""
    }
  }, [_c('v-card-text', [_c('p', {
    staticClass: "font-size-14 font-weight-medium primary--text mb-2"
  }, [_vm._v("자동응찰이란?")]), _c('p', {
    staticClass: "font-size-14 grey-68--text"
  }, [_vm._v("자동응찰가를 설정하면, 다른응찰에 "), _c('br'), _vm._v("대응하여 설정한 금액까지 자동 응찰됩니다.")])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }